module.exports = __webpack_public_path__ + "img/d5.439605ac.png";